import api from '../../api';
import { push } from 'connected-react-router';
import { store as storeNotification } from 'react-notifications-component';
import { socket } from './../store/socket';

const notificationConfig = {
  container: 'top-center',
  animationIn: ['animated', 'fadeIn'],
  animationOut: ['animated', 'fadeOut'],
  dismiss: {
    duration: 1500,
    showIcon: true
  }
};

export const veterinariansStartRequest = () => {
  return {
    type: 'VETERINARIANS_START_REQUEST'
  };
};

export const veterinariansEndRequest = () => {
  return {
    type: 'VETERINARIANS_END_REQUEST'
  };
};

export const getAllVeterinariansSuccess = ({ data }) => {
  return {
    type: 'VETERINARIANS_GET_ALL_SUCCESS',
    payload: data
  };
};

export const getAllVeterinariansError = error => {
  return {
    type: 'VETERINARIANS_GET_ALL_ERROR',
    payload: error
  };
};

export const addVeterinariansSuccess = ({ data }) => {
  return {
    type: 'VETERINARIANS_ADD_SUCCESS',
    payload: data
  };
};

export const addVeterinariansError = error => {
  return {
    type: 'VETERINARIANS_ADD_ERROR',
    payload: error
  };
};

export const editVeterinariansSuccess = ({ data }) => {
  return {
    type: 'VETERINARIANS_EDIT_SUCCESS',
    payload: data
  };
};

export const editVeterinariansError = error => {
  return {
    type: 'VETERINARIANS_EDIT_ERROR',
    payload: error
  };
};

export const removeVeterinariansSuccess = id => {
  return {
    type: 'VETERINARIANS_REMOVE_SUCCESS',
    payload: id
  };
};

export const removeVeterinariansError = error => {
  return {
    type: 'VETERINARIANS_REMOVE_ERROR',
    payload: error
  };
};

export const veterinariansModifyStore = ({ data }) => {
  return {
    type: 'VETERINARIANS_MODIFY_STORE',
    payload: data
  };
};

export const addVeterinarians = (data, formReset, submitBtn) => {
  return async dispatch => {
    try {
      submitBtn.disabled = true;
      dispatch(veterinariansStartRequest());
      const response = await api().post('/api/veterinarians', data);
      dispatch(addVeterinariansSuccess(response));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'ADD',
        module: 'veterinarians',
        data: [response.data],
        company: response.data.company
      });
      formReset();
    } catch (err) {
      dispatch(addVeterinariansError(err));
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      setTimeout(() => {
        dispatch(veterinariansEndRequest());
        submitBtn.disabled = false;
      }, 1800);
    }
  };
};

export const getAllVeterinarians = (params = {}) => {
  return async dispatch => {
    try {
      dispatch(veterinariansStartRequest());
      const response = await api().get('/api/veterinarians', { params });
      dispatch(getAllVeterinariansSuccess(response));
    } catch (err) {
      dispatch(getAllVeterinariansError(err));
    } finally {
      dispatch(veterinariansEndRequest());
    }
  };
};

export const editVeterinarians = (data, submitBtn = {}, handleModalClose) => {
  return async dispatch => {
    const defaultMsg = button => {
      return new Promise(resolve => {
        document
          .getElementsByClassName('page-content')[0]
          .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        setTimeout(() => {
          dispatch(veterinariansEndRequest());
          button.disabled = false;
          resolve(true);
        }, 1800);
      });
    };

    try {
      submitBtn.disabled = true;
      dispatch(veterinariansStartRequest());
      const id = data._id;
      const response = await api().put('/api/veterinarians/' + id, data);
      dispatch(editVeterinariansSuccess(response));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'EDIT',
        module: 'veterinarians',
        data: [response.data],
        company: response.data.company
      });
      await defaultMsg(submitBtn);
      if (handleModalClose) {
        handleModalClose();
      } else {
        dispatch(push('/veterinarians'));
      }
    } catch (err) {
      dispatch(editVeterinariansError(err));
      await defaultMsg(submitBtn);
    }
  };
};

export const removeVeterinarians = id => {
  return async dispatch => {
    try {
      dispatch(veterinariansStartRequest());
      await api().delete('/api/veterinarians/' + id);
      dispatch(removeVeterinariansSuccess(id));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'REMOVE',
        module: 'veterinarians',
        data: id
      });
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Veterinário removido com sucesso.',
          type: 'success'
        });
      }, 300);
    } catch (err) {
      dispatch(removeVeterinariansError(err));
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Falha ao remover veterinário.',
          type: 'danger'
        });
      }, 300);
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      dispatch(veterinariansEndRequest());
    }
  };
};

export const restoreVeterinarians = data => {
  return async dispatch => {
    try {
      dispatch(veterinariansStartRequest());
      const id = data._id;
      const response = await api().put('/api/veterinarians/' + id, data);
      dispatch(editVeterinariansSuccess(response));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'RESTORE',
        module: 'veterinarians',
        data: [response.data],
        company: response.data.company
      });
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Veterinário restaurado com sucesso.',
          type: 'success'
        });
      }, 300);
    } catch (err) {
      dispatch(editVeterinariansError(err));
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Falha ao restaurar veterinário.',
          type: 'danger'
        });
      }, 300);
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      dispatch(veterinariansEndRequest());
    }
  };
};
